import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { AIContext } from '@/modules/AiAgents/context/nugzContext/context';
import { AIActionsTypes } from '@/modules/AiAgents/context/nugzContext/reducer';

const CancelEditButton = () => {
  const { t } = useTranslation('common');
  const { dispatch } = useContext(AIContext);

  const handleCancelEdit = () => {
    dispatch({
      type: AIActionsTypes.setIsEditing,
      payload: false,
    });
  };

  return (
    <div
      className='cursor-pointer text-base font-semi-bold text-error-400'
      onClick={handleCancelEdit}
    >
      {t('cancel')}
    </div>
  );
};

export { CancelEditButton };
